import React, { useMemo } from 'react';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleAuditLogDetails = () => {
  const { logId } = useParams();
  const decodedId = logId ? atob(logId) : logId;
  const id = /^[0-9a-fA-F-]{36}$/.test(decodedId) ? decodedId : decodedId.replace(/\D/g, '');

  const url = id ? `${API_DOMAIN}${API_ROUTES['auditLog']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at', 'uuid', 'tenant_id'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Audit Log"
        listPath="/security/audit-log/list"
      />
    </div>
  );
};

export default SingleAuditLogDetails;
